import { Component, DestroyRef, inject, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { ShUserIdentifierComponent } from '@gbr-monorepo/gbr-shui';
import { GbrUser, LanguageCode } from '@gbr-monorepo/interfaces';
import { filter } from 'rxjs';
import { LanguageSwitchComponent } from '../language-switch/language-switch.component';

@Component({
    selector: 'app-shared-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, LanguageSwitchComponent, ShUserIdentifierComponent]
})
export class HeaderComponent {
    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    public readonly appName = input.required<string>();
    public readonly homeAriaLabel = input.required<string>();
    public readonly selectedLang = input<LanguageCode>(LanguageCode.EN);
    public readonly user = input<GbrUser | undefined>(undefined);
    public readonly profilePicture = input<string | undefined>(undefined);
    public readonly allowProfilePicture = input(false);
    public readonly hideUserControls = input(false);
    public readonly languageChanged = output<LanguageCode>();

    protected readonly logoInteractive = signal(false);

    public constructor() {
        this.router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe((event: NavigationEnd): void => {
                this.logoInteractive.set(event.urlAfterRedirects !== '/');
            });
    }

    protected changeLanguage(language: LanguageCode): void {
        this.languageChanged.emit(language);
    }
}
